import type { CondicaoPagamento } from '../../db/tipos'
import type { QuadroDaTabela as Quadro } from '../../precos/rascunhoDaTabela'
import type { RegraRascunho } from '../../representadas/rascunhoDaPolitica'
import { rotuloCurtoDaCondicao } from '../../representadas/condicoesDaTabela'
import CardRegra from './CardRegra'
import { ESTILO_CARTAO_NOVO } from './estilosDaFornecedora'

// Quadro no topo da tela Editar (spec 2.2): o que antes ficava dentro do card.
export default function QuadroDaTabela({ representadaId, quadro, condicoes, resumoFornecedora, erro, aoMudar, aoCriarPropria, aoUsarFornecedora }: {
  representadaId: string
  quadro: Quadro
  condicoes: CondicaoPagamento[] // salvas e vivas, em ordem
  resumoFornecedora: string // ex.: "Comissão 1,50%"
  erro?: string
  aoMudar: (q: Quadro) => void
  aoCriarPropria: () => void
  aoUsarFornecedora: () => void
}) {
  const alternar = (id: string) =>
    aoMudar({ ...quadro, condicoes: quadro.condicoes.includes(id) ? quadro.condicoes.filter((c) => c !== id) : [...quadro.condicoes, id] })
  return (
    <div data-testid="quadro-tabela" className={`${ESTILO_CARTAO_NOVO} space-y-3`}>
      <label className="flex items-center justify-between text-sm font-medium text-slate-800">
        Tabela ativa
        <input type="checkbox" role="switch" checked={quadro.ativa} onChange={() => aoMudar({ ...quadro, ativa: !quadro.ativa })} className="h-5 w-5" />
      </label>
      {condicoes.length > 0 && (
        <fieldset className="space-y-1">
          <legend className="text-[11px] text-slate-500">Prazos em que vale (nenhum marcado = vale em todos)</legend>
          <div className="flex flex-wrap gap-1.5">
            {condicoes.map((c) => {
              const marcada = quadro.condicoes.includes(c.id)
              return (
                <label key={c.id} className={`text-xs rounded-full border px-2 py-1 ${marcada ? 'bg-teal-700 text-white border-teal-700' : 'border-slate-300 text-slate-700'}`}>
                  <input type="checkbox" className="sr-only" checked={marcada} onChange={() => alternar(c.id)} />
                  {rotuloCurtoDaCondicao(c.descricao)}
                </label>
              )
            })}
          </div>
        </fieldset>
      )}
      <div className="space-y-1">
        <p className="text-[11px] text-slate-500">Comissão da tabela</p>
        {quadro.regra ? (
          <>
            <CardRegra representadaId={representadaId} rascunho={quadro.regra} regraSalva={undefined} erro={erro} editavel
              aoMudar={(p: Partial<RegraRascunho>) => aoMudar({ ...quadro, regra: { ...quadro.regra!, ...p } })} />
            <button type="button" onClick={aoUsarFornecedora} className="text-xs text-slate-600 underline">Usar a comissão da fornecedora</button>
          </>
        ) : (
          <>
            <p className="text-xs text-slate-700">Usa a comissão da fornecedora: {resumoFornecedora}</p>
            <button type="button" onClick={aoCriarPropria} className="text-xs text-teal-800 underline">Criar comissão própria</button>
          </>
        )}
      </div>
    </div>
  )
}
